import React from "react";
import { BsChevronDown } from "react-icons/bs";
import LocationDropdownOptions from "./LocationDropdownOptions";

const LocationDropdown = ({
  displayLocations,
  displayLocationDropdown,
  location,
  locations,
  onLocationChange,
  setLocationSelectedFromDropdownMenu,
}) => {
  return (
    <div className="location-filter-wrapper" style={{ paddingTop: 0, position: "relative", width: "100%" }}>
      <div style={{ display: "flex", alignItems: "center", width: "100%", gap: 8 }}>
        <label style={{ fontWeight: 500, marginBottom: 0 }}>Location:</label>
        <div
          tabIndex="0"
          className="selectpicker form-control"
          onClick={(e) => displayLocationDropdown(e)}
          onKeyDown={(e) => e.code === "Enter" && displayLocationDropdown(e)}
          style={{ position: "relative", zIndex: 1001, flex: 1, minWidth: 0 }}
          role="combobox"
          aria-label="select-location"
          aria-expanded={displayLocations ? "true" : "false"}
          aria-controls="location-dropdown-menu"
        >
          <span style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {location ? location.LocationDesc : "All Locations"}
            </span>
            <span>
              <BsChevronDown />
            </span>
          </span>
        </div>
      </div>
      <div
        className="location-dropdown"
        id="location-dropdown-menu"
        style={!displayLocations ? { display: "none" } : { display: "block" }}
      >
        {locations && (
          <LocationDropdownOptions
            displayLocations={displayLocations}
            displayLocationDropdown={displayLocationDropdown}
            locations={locations}
            onLocationChange={onLocationChange}
            setLocationSelectedFromDropdownMenu={
              setLocationSelectedFromDropdownMenu
            }
          />
        )}
      </div>
    </div>
  );
};

export default LocationDropdown;
